export default {
      id: "oc-icon_monitor_vnc-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_monitor_vnc",
      toString: function () {
        return this.url;
      }
    }